import { createAcpResource } from 'syft-acp-core/api/resource'

export const resPricingPlans = createAcpResource('resPricingPlans', {
  uri: ['/admin/sales/pricing_plans', 'GET'],
})
